import axios from "axios"
import { v4 as uuidv4 } from "uuid"

const api = axios.create({
    baseURL: "https://api3.onbetsports.com.br",
    headers: {
        "Content-Type": "application/json",
    },
})

api.interceptors.request.use((config) => {

    config.headers["X-Interaction-Id"] = uuidv4()

    const token = localStorage.getItem("token")

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})

api.interceptors.response.use(
    (response) => response,
    (error) => {

        if (error.response?.status === 401) {
            localStorage.removeItem("token")
        }

        return Promise.reject(error)
    }
)

export default api